// extracted by mini-css-extract-plugin
export default {"finalSection":"FinalSection_finalSection__BHzLV"};